/*
 * EM Bookmarks — Save packs + compare 2 packs
 * Storage : localStorage 'em_pack_bookmarks' = [ { id, name, handle, url, size, theme, themeLabel, total, articles, savedAt } ]
 * Max 6 bookmarks
 */
(function () {
  const STORAGE_KEY = 'em_pack_bookmarks';
  const MAX_BOOKMARKS = 6;
  const PACK_META = window.EM_PACK_META;
  if (!PACK_META) return;

  /* ---------- Storage helpers ---------- */
  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function save(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }

  function isBookmarked(id) { return load().some(b => b.id === id); }

  function addBookmark() {
    const list = load();
    if (list.find(b => b.id === PACK_META.id)) return;
    if (list.length >= MAX_BOOKMARKS) list.shift();
    // Capture current totals from the page
    const totalEl = document.querySelector('[data-total-price]');
    const countEl = document.querySelector('[data-total-count]');
    const productsEl = document.querySelector('[data-total-products]');
    list.push({
      id: PACK_META.id,
      name: PACK_META.name,
      handle: PACK_META.handle,
      size: PACK_META.size,
      theme: PACK_META.theme,
      themeLabel: PACK_META.themeLabel,
      url: PACK_META.url,
      total: totalEl ? totalEl.textContent.trim() : '',
      articles: countEl ? countEl.textContent.trim() : '',
      products: productsEl ? productsEl.textContent.trim() : '',
      savedAt: Math.floor(Date.now() / 1000),
    });
    save(list);
  }
  function removeBookmark(id) { save(load().filter(b => b.id !== id)); }

  /* ---------- DOM refs ---------- */
  const btn = document.querySelector('[data-em-bookmark-toggle]');
  const labelEl = document.querySelector('[data-em-bookmark-label]');
  const fab = document.querySelector('[data-em-bookmarks-fab]');
  const fabCount = document.querySelector('[data-em-bookmarks-fab-count]');
  const drawer = document.querySelector('[data-em-bookmarks-drawer]');
  const listEl = document.querySelector('[data-em-bookmarks-list]');
  const hintEl = document.querySelector('[data-em-bookmarks-hint]');
  const compareBtn = document.querySelector('[data-em-bookmarks-compare]');
  const compareView = document.querySelector('[data-em-bookmarks-compare-view]');
  const compareCols = document.querySelector('[data-em-bookmarks-compare-cols]');
  const compareBack = document.querySelector('[data-em-bookmarks-compare-back]');

  /* ---------- UI sync ---------- */
  function updateToggleUI() {
    if (!btn) return;
    const bm = isBookmarked(PACK_META.id);
    btn.classList.toggle('em-pack__bookmark-btn--on', bm);
    btn.setAttribute('aria-pressed', bm ? 'true' : 'false');
    if (labelEl) labelEl.textContent = bm ? 'Pack sauvegardé' : 'Sauvegarder ce pack';
  }
  function updateFab() {
    const list = load();
    if (!fab) return;
    fab.hidden = list.length === 0;
    if (fabCount) fabCount.textContent = list.length;
  }
  function updateAll() { updateToggleUI(); updateFab(); }

  /* ---------- Drawer ---------- */
  function openDrawer() {
    if (!drawer) return;
    renderList();
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    showList();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function showList() {
    if (compareView) compareView.hidden = true;
    if (listEl) listEl.hidden = false;
    if (hintEl) hintEl.hidden = false;
    if (compareBtn) compareBtn.parentElement.hidden = false;
  }
  function showCompareView() {
    if (listEl) listEl.hidden = true;
    if (hintEl) hintEl.hidden = true;
    if (compareBtn) compareBtn.parentElement.hidden = true;
    if (compareView) compareView.hidden = false;
  }

  function renderList() {
    if (!listEl) return;
    const list = load();
    if (list.length === 0) {
      listEl.innerHTML = `<div class="em-bookmarks-drawer__empty">
        <p>Aucun pack sauvegardé pour l'instant.</p>
        <p>Cliquez sur le bouton <strong>« Sauvegarder ce pack »</strong> sur n'importe quel pack pour le retrouver ici.</p>
      </div>`;
      if (compareBtn) compareBtn.disabled = true;
      return;
    }
    listEl.innerHTML = list.map(b => `
      <label class="em-bookmarks-drawer__item" data-id="${escapeHtml(b.id)}">
        <input type="checkbox" class="em-bookmarks-drawer__check" value="${escapeHtml(b.id)}">
        <div class="em-bookmarks-drawer__info">
          <div class="em-bookmarks-drawer__name">${escapeHtml(b.name)}</div>
          <div class="em-bookmarks-drawer__meta">
            <span class="em-bookmarks-drawer__price">${escapeHtml(b.total || '—')}</span>
            <span class="em-bookmarks-drawer__sep">·</span>
            <span>${escapeHtml(b.products || '?')} produits</span>
            <span class="em-bookmarks-drawer__sep">·</span>
            <span>${escapeHtml(b.articles || '?')} articles</span>
          </div>
        </div>
        <div class="em-bookmarks-drawer__actions">
          <a class="em-bookmarks-drawer__view" href="${escapeHtml(b.url)}">Voir</a>
          <button type="button" class="em-bookmarks-drawer__remove" data-remove="${escapeHtml(b.id)}" aria-label="Retirer">×</button>
        </div>
      </label>
    `).join('');
    updateCompareBtnState();
  }
  function updateCompareBtnState() {
    if (!compareBtn) return;
    const checked = drawer.querySelectorAll('.em-bookmarks-drawer__check:checked').length;
    compareBtn.disabled = checked !== 2;
    compareBtn.textContent = checked === 2 ? 'Comparer ces 2 packs' : `Comparer les packs cochés (${checked}/2)`;
  }

  function renderCompare(ids) {
    if (!compareCols) return;
    const list = load();
    const packs = ids.map(id => list.find(b => b.id === id)).filter(Boolean);
    compareCols.innerHTML = packs.map(p => `
      <div class="em-bookmarks-compare__col">
        <h3 class="em-bookmarks-compare__name">${escapeHtml(p.name)}</h3>
        <div class="em-bookmarks-compare__price">${escapeHtml(p.total || '—')}</div>
        <dl class="em-bookmarks-compare__stats">
          <div><dt>Produits</dt><dd>${escapeHtml(p.products || '?')}</dd></div>
          <div><dt>Articles</dt><dd>${escapeHtml(p.articles || '?')}</dd></div>
          <div><dt>Thème</dt><dd>${escapeHtml(p.themeLabel || '?')}</dd></div>
          <div><dt>Taille</dt><dd>${escapeHtml(p.size || '?')}</dd></div>
        </dl>
        <a class="em-bookmarks-compare__cta" href="${escapeHtml(p.url)}">Voir le détail →</a>
      </div>
    `).join('');
    showCompareView();
  }

  /* ---------- Events ---------- */
  if (btn) {
    btn.addEventListener('click', () => {
      if (isBookmarked(PACK_META.id)) {
        removeBookmark(PACK_META.id);
      } else {
        addBookmark();
      }
      updateAll();
    });
  }

  if (fab) fab.addEventListener('click', openDrawer);
  document.querySelectorAll('[data-em-bookmarks-close]').forEach(el => el.addEventListener('click', closeDrawer));

  if (listEl) {
    listEl.addEventListener('change', e => {
      if (e.target.matches('.em-bookmarks-drawer__check')) {
        // Cap at 2 checks
        const checks = listEl.querySelectorAll('.em-bookmarks-drawer__check:checked');
        if (checks.length > 2) {
          e.target.checked = false;
          return;
        }
        updateCompareBtnState();
      }
    });
    listEl.addEventListener('click', e => {
      const removeBtn = e.target.closest('[data-remove]');
      if (removeBtn) {
        e.preventDefault();
        removeBookmark(removeBtn.dataset.remove);
        renderList();
        updateFab();
        updateToggleUI();
      }
    });
  }

  if (compareBtn) {
    compareBtn.addEventListener('click', () => {
      const ids = Array.from(drawer.querySelectorAll('.em-bookmarks-drawer__check:checked')).map(c => c.value);
      if (ids.length === 2) renderCompare(ids);
    });
  }
  if (compareBack) compareBack.addEventListener('click', showList);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  /* ===================== PARTAGE (WhatsApp / SMS / Mail / Copy / Native) ===================== */
  const shareRoot = document.querySelector('[data-em-share-root]');
  const shareToggle = document.querySelector('[data-em-share-toggle]');
  const shareMenu = document.querySelector('[data-em-share-menu]');
  const shareCopyLabel = document.querySelector('[data-em-share-copy-label]');

  function getShareData() {
    const totalEl = document.querySelector('[data-total-price]');
    const total = totalEl ? totalEl.textContent.trim() : '';
    // L'URL partagée inclut le hash custom (#em=...) pour transmettre les modifs
    const url = window.location.origin + window.location.pathname + window.location.hash;
    const title = PACK_META.name;
    const text = `Regarde ce pack qui pourrait nous intéresser : ${title}${total ? ' — ' + total : ''} sur Easy Mobilier`;
    return { title, text, url };
  }

  function setShareHrefs() {
    if (!shareMenu) return;
    const { title, text, url } = getShareData();
    const fullText = `${text}\n${url}`;
    const enc = encodeURIComponent;
    shareMenu.querySelectorAll('[data-em-share]').forEach(el => {
      const kind = el.dataset.emShare;
      if (kind === 'whatsapp') el.href = `https://wa.me/?text=${enc(fullText)}`;
      else if (kind === 'sms') el.href = `sms:?body=${enc(fullText)}`;
      else if (kind === 'mail') el.href = `mailto:?subject=${enc(title)}&body=${enc(fullText)}`;
    });
  }

  function openShareMenu() {
    if (!shareMenu) return;
    setShareHrefs();
    shareMenu.hidden = false;
    shareToggle?.setAttribute('aria-expanded', 'true');
  }
  function closeShareMenu() {
    if (!shareMenu) return;
    shareMenu.hidden = true;
    shareToggle?.setAttribute('aria-expanded', 'false');
  }

  // Met à jour les hrefs quand le state pack change (qty +/-, retrait)
  document.addEventListener('em:pack-state-change', setShareHrefs);

  if (shareToggle) {
    shareToggle.addEventListener('click', async (e) => {
      e.stopPropagation();
      // Web Share API natif (mobile principalement)
      if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
        try {
          await navigator.share(getShareData());
          return;
        } catch (err) { /* user cancelled — fall through to menu */ }
      }
      // Desktop ou pas de Web Share : menu
      if (shareMenu && shareMenu.hidden) openShareMenu();
      else closeShareMenu();
    });
  }

  /* ===================== EMAIL MODAL (avec champs préremplis) ===================== */
  const emailModal = document.querySelector('[data-em-email-modal]');
  const emailForm = document.querySelector('[data-em-email-form]');
  const emailToInput = document.querySelector('[data-em-email-to]');
  const emailSubjectInput = document.querySelector('[data-em-email-subject]');
  const emailBodyInput = document.querySelector('[data-em-email-body]');

  function openEmailModal() {
    if (!emailModal) return;
    const { title, url } = getShareData();
    const totalEl = document.querySelector('[data-total-price]');
    const total = totalEl ? totalEl.textContent.trim() : '';
    // Pré-remplir objet + message
    if (emailSubjectInput) emailSubjectInput.value = `${title}${total ? ' — ' + total : ''} sur Easy Mobilier`;
    if (emailBodyInput) emailBodyInput.value =
      `Bonjour,\n\nRegarde ce pack qui pourrait nous intéresser : ${title}${total ? ' — ' + total : ''} sur Easy Mobilier.\n\nVoici le lien direct :\n${url}\n\nÀ bientôt.`;
    closeShareMenu();
    emailModal.hidden = false;
    setTimeout(() => emailToInput?.focus(), 50);
  }
  function closeEmailModal() {
    if (!emailModal) return;
    emailModal.hidden = true;
  }

  // Trigger : clic sur Email → ouvre le modal email (envoi automatique)
  document.querySelectorAll('[data-em-share="mail-open"]').forEach(btn => {
    btn.addEventListener('click', openEmailModal);
  });
  document.querySelectorAll('[data-em-email-close]').forEach(el => {
    el.addEventListener('click', closeEmailModal);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && emailModal && !emailModal.hidden) closeEmailModal();
  });

  /* ===== EmailJS Configuration =====
     Branche Brevo SMTP côté EmailJS, puis renseigne ces 3 IDs.
     Setup détaillé :
       1. Inscription sur https://emailjs.com (gratuit)
       2. "Email Services" → Add new → "Brevo (SendinBlue)" (ou "Custom SMTP" : host smtp-relay.brevo.com, port 587, user/pass = creds SMTP Brevo)
       3. "Email Templates" → New Template avec ces variables Liquid :
              To: {{to_email}}
              From Name: Easy Mobilier (par défaut)
              Subject: {{subject}}
              Body: {{message}}
       4. "Account" → Onglet API Keys → copier "Public Key"
       5. Notes the 3 IDs et les coller ci-dessous.
       6. Dans EmailJS : "Account → Security" → activer "Allow EmailJS API only from your website" → mettre le domaine.
  ============================================= */
  const EMAILJS_PUBLIC_KEY  = 'TODO_PUBLIC_KEY';
  const EMAILJS_SERVICE_ID  = 'TODO_SERVICE_ID';
  const EMAILJS_TEMPLATE_ID = 'TODO_TEMPLATE_ID';

  // Charge la SDK EmailJS de manière lazy (seulement quand le modal s'ouvre)
  let emailJsLoaded = false;
  function loadEmailJs() {
    return new Promise((resolve, reject) => {
      if (emailJsLoaded && window.emailjs) return resolve();
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
      s.async = true;
      s.onload = () => {
        if (window.emailjs && EMAILJS_PUBLIC_KEY && !EMAILJS_PUBLIC_KEY.startsWith('TODO')) {
          window.emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY });
        }
        emailJsLoaded = true;
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  // Status badge (envoyé/erreur) inséré dynamiquement dans le modal
  function setEmailStatus(text, ok) {
    const form = emailForm;
    if (!form) return;
    let badge = form.querySelector('.em-pack__email-status');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'em-pack__email-status';
      form.querySelector('.em-pack__email-actions').insertAdjacentElement('beforebegin', badge);
    }
    badge.textContent = text;
    badge.dataset.state = ok ? 'ok' : 'error';
  }

  // Pre-load SDK quand le modal s'ouvre (sans bloquer l'UI)
  const _origOpenEmailModal = openEmailModal;
  openEmailModal = function () {
    _origOpenEmailModal();
    loadEmailJs().catch(() => {});
  };

  if (emailForm) {
    emailForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const to = (emailToInput?.value || '').trim();
      const subject = (emailSubjectInput?.value || '').trim();
      const body = (emailBodyInput?.value || '').trim();
      if (!to) return;

      const submitBtn = emailForm.querySelector('.em-pack__email-btn--primary');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Envoi en cours…'; }

      try {
        await loadEmailJs();

        // Fallback mailto si EmailJS pas encore configuré (les TODO sont là)
        if (!window.emailjs || EMAILJS_PUBLIC_KEY.startsWith('TODO')) {
          const enc = encodeURIComponent;
          window.location.href = `mailto:${enc(to)}?subject=${enc(subject)}&body=${enc(body)}`;
          closeEmailModal();
          return;
        }

        // Vraie envoi automatique via EmailJS → Brevo SMTP
        await window.emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
          to_email: to,
          subject: subject,
          message: body,
          pack_name: PACK_META.name,
          pack_url: getShareData().url,
        });
        setEmailStatus('✓ Email envoyé avec succès', true);
        setTimeout(() => { closeEmailModal(); }, 1200);
      } catch (err) {
        console.error('[em-bookmarks] EmailJS send failed', err);
        setEmailStatus('Échec de l\'envoi — réessayez ou contactez-nous.', false);
      } finally {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Envoyer'; }
      }
    });
  }

  // Refresh href JUST BEFORE navigation pour chaque <a> de partage
  // (au cas où l'event em:pack-state-change ne s'est pas propagé correctement)
  if (shareMenu) {
    shareMenu.querySelectorAll('a[data-em-share]').forEach(el => {
      ['pointerdown', 'click'].forEach(evt => {
        el.addEventListener(evt, () => {
          const { title, text, url } = getShareData();
          const fullText = `${text}\n${url}`;
          const enc = encodeURIComponent;
          const kind = el.dataset.emShare;
          if (kind === 'whatsapp') el.href = `https://wa.me/?text=${enc(fullText)}`;
          else if (kind === 'sms') el.href = `sms:?body=${enc(fullText)}`;
          else if (kind === 'mail') el.href = `mailto:?subject=${enc(title)}&body=${enc(fullText)}`;
        });
      });
    });
  }

  // Copy link option — toujours l'URL fraîche (lit window.location.hash live)
  document.querySelectorAll('[data-em-share="copy"]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const { url } = getShareData();
      try {
        await navigator.clipboard.writeText(url);
        if (shareCopyLabel) {
          shareCopyLabel.textContent = '✓ Lien copié';
          setTimeout(() => { shareCopyLabel.textContent = 'Copier le lien'; }, 1800);
        }
      } catch (e) { console.warn('clipboard failed', e); }
    });
  });

  // Close menu on click outside
  document.addEventListener('click', e => {
    if (shareMenu && !shareMenu.hidden && shareRoot && !shareRoot.contains(e.target)) {
      closeShareMenu();
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && shareMenu && !shareMenu.hidden) closeShareMenu();
  });

  /* ---------- Init ---------- */
  updateAll();
  setShareHrefs(); // Initialise les hrefs (sinon les liens apparaissent grisés)
})();
